module.exports = __webpack_public_path__ + "static/media/page2_header.740b0bcb.jpg";